import React, { useState } from "react";
import { Card, Row, Col } from "react-bootstrap";
import style from "../ThemesLayout.module.css";
import ColorPallete from "./ColorPallete";
import MoreIcon from "@material-ui/icons/MoreVert";
import { useTranslation } from "react-i18next";
import { downloadJson } from "../../../../../Resources/globalFunctions";
import { deleteTheme } from "../../../../../components/IFormDesignerLayout/RequestLogic";
import { ClickAwayListener } from "@material-ui/core";
import { GetStateFromData } from "../../../../CustomHooks/CustomHooks";

const ThemeDescriptionCard = (props) => {
  const contexts = GetStateFromData(props.containerId);

  const { t } = useTranslation();

  const { showAlertConfirmNotifications } = contexts.contexts;

  const [colorPalleteColors, setColorPalleteColors] = useState(
    props.themeDetails &&
      props.themeDetails["BasicTheme"] &&
      props.themeDetails["BasicTheme"]["colorPallete"]
      ? props.themeDetails["BasicTheme"]["colorPallete"]
      : []
  );

  const [themeActionDetails, setThemeActionDetails] = useState({});

  const handleClickAway = () => {
    setThemeActionDetails({});
  };

  function showThemeActions(event, action, themeType, themeIndex) {
    event.stopPropagation();
    if (props.themeDetails && action == "downloadTheme") {
      var themeName = "Theme";
      if (props.themeDetails.themeName)
        themeName = props.themeDetails.themeName;

      downloadJson(props.themeDetails, themeName);
      setThemeActionDetails({});
    } else if (props.themeDetails && action === "deleteTheme") {
      var jsonToSend = {
        themeName: props?.themeDetails?.themeName,
      };

      deleteTheme(jsonToSend).then((response) => {
        if (response && response.status === 200) {
          props.deleteThemeUI(props.themeIndex);

          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "success",
            vertical: "bottom",
            horizontal: "left",
            autoHideDuration: 4000,
            alertContentKey: "THEME_DELETED_SUCCESSFULLY",
          });
        }
      });
    } else {
      setThemeActionDetails({ themeType: themeType, themeIndex: themeIndex });
    }
  }
  function handleSelectedTheme(themeType, themeIndex) {
    setThemeActionDetails({});
    props.handleSelectedTheme(themeType, themeIndex);
  }

  return (
    <Card.Body
      tabIndex={0}
      themeType={props.themeType}
      themeIndex={props.themeIndex}
      className={[
        style.themeDescriptionCard,
        props.themeSelected === true
          ? style.selectedThemeDescriptionCard
          : null,
        props.selectedThemeCustom === props.themeIndex
          ? style.selectedThemeCustomDescriptionCard
          : null,
        props.selectedThemeSystem === props.themeIndex
          ? style.selectedThemeCustomDescriptionCard
          : null,
      ]}
      onClick={() => handleSelectedTheme(props.themeType, props.themeIndex)}
    >
      <Row
        className={style.themeNameRow}
        onClick={() =>
          props.handleSelectedTheme(props.themeType, props.themeIndex)
        }
      >
        {props.themeDetails && props.themeDetails["themeName"]
          ? props.themeDetails["themeName"]
          : t("Theme name")}
        <div className={style.aplliedDots}>
          {props.themeApplied === true ? (
            <Col className={style.appliedThemeCol}>{t("Applied")}</Col>
          ) : (
            <></>
          )}
          {(props?.themeDetails?.["themeName"] || props.themeApplied !== true) && (
          <div
            style={
              window?.psh_configs?.selectedLanguage === "ar" ||
              window?.psh_configs?.selectedLanguage === "ar-SA"
                ? { marginRight: "15px" }
                : { marginRight: "-9px" }
            }
          >
            <MoreIcon
              className={style.themeActionDots}
              onClick={(event) =>
                showThemeActions(
                  event,
                  "showOptions",
                  props.themeType,
                  props.themeIndex
                )
              }
            />
          </div>
          )}
        </div>
      </Row>

      <Row
        className={style.themeDescriptionColorPalleteRow}
        onClick={() =>
          props.handleSelectedTheme(props.themeType, props.themeIndex)
        }
      >
        <ColorPallete
          colorPalletBoxStyle={colorPalleteColors}
          width="17px"
          height="20px"
        />
        {themeActionDetails["themeType"] === props.themeType &&
        themeActionDetails["themeIndex"] === props.themeIndex ? (
          <ClickAwayListener
            mouseEvent="onMouseDown"
            touchEvent="onTouchStart"
            onClickAway={handleClickAway}
          >
            <div
              key={
                themeActionDetails["themeType"] +
                themeActionDetails["themeIndex"]
              }
              className={
                props.themeType === "userDefinedThemes"
                  ? style.themeActionDiv
                  : style.themeActionDiv2
              }
              style={
                window?.psh_configs?.selectedLanguage === "ar" ||
                window?.psh_configs?.selectedLanguage === "ar-SA"
                  ? { left: "-23%", right: "unset" }
                  : { right: "-29%", left: "unset" }
              }
            >
              {props?.themeDetails?.["themeName"] && (
              <Col
                className={style.themeActionText}
                onClick={(event) => showThemeActions(event, "downloadTheme")}
              >
                <img
                  src={
                    require("../../../../../Icons/DownloadTheme.svg").default
                  }
                  className={style.themeActionImg}
                  alt="Download Theme"
                />
                <span>{t("Download")}</span>
              </Col>
              )}
              {props.themeType === "userDefinedThemes" ? (
                <>
                  <Col
                    className={style.themeActionText}
                    onClick={(event) => showThemeActions(event, "deleteTheme")}
                  >
                    <img
                      src={
                        require("../../../../../Icons/DeleteTheme.svg").default
                      }
                      className={style.themeActionImg}
                      alt="Delete Theme"
                    />
                    <span>{t("Delete")}</span>
                  </Col>
                </>
              ) : (
                ""
              )}
            </div>
          </ClickAwayListener>
        ) : (
          <></>
        )}
      </Row>
      <Row
        className={style.themeContentBasicInformationRow}
        onClick={() =>
          props.handleSelectedTheme(props.themeType, props.themeIndex)
        }
      >
        <Col
          className={style.themeContentBasicInformationCol}
          onClick={() =>
            props.handleSelectedTheme(props.themeType, props.themeIndex)
          }
        >
          <img
            src={require("../../../../../Icons/CompactTheme.svg").default}
            className={style.themeDescriptionImg}
            alt="Compact Theme"
          />
          {t("Compact")}
        </Col>
        <Col
          className={[
            style.themeContentBasicInformationCol,
            style.themeContentBasicInformationCol2,
          ].join(" ")}
        >
          <img
            src={require("../../../../../Icons/ContrastTheme.svg").default}
            className={style.themeDescriptionImg}
            alt="Contrast Theme"
          />
          {t("High Contrast")}
        </Col>
      </Row>
      <Row
        style={{ marginLeft: "-10px" }}
        className={style.themeContentBasicInformationRow}
        onClick={() =>
          props.handleSelectedTheme(props.themeType, props.themeIndex)
        }
      >
        <Col
          className={style.themeContentBasicInformationCol}
          onClick={() =>
            props.handleSelectedTheme(props.themeType, props.themeIndex)
          }
        >
          <img
            src={require("../../../../../Icons/Icon open-text.svg").default}
            className={style.themeDescriptionImg}
            alt="Open Text"
          />
          {t("Open Sans(aA-Regular)")}
        </Col>
      </Row>
    </Card.Body>
  );
};

export default ThemeDescriptionCard;
